import React, { FC } from 'react';
import { FieldErrors, FieldValues } from 'react-hook-form';

import styles from './index.module.sass';

interface ErrorsProps {
  api: string;
  email: FieldErrors<FieldValues>;
  phone: FieldErrors<FieldValues>;
}

const Errors: FC<ErrorsProps> = ({ api, email, phone }) => (
  <>
    {api ? (
      <div className={styles.error}>{api}</div>
    ) : (
      <>
        {Object.keys( email ).map(( error ) => (
          <div className={styles.error} key={error}>
            {email[error]?.message}
          </div>
        ))}

        {Object.keys( phone ).map(( error ) => (
          <div className={styles.error} key={error}>
            {phone[error]?.message ?? 'Mobile number is not correct.'}
          </div>
        ))}
      </>
    )}
  </>
);

export default Errors;
